import axios from "axios";

const getApiBaseUrl = () => {
  if (window._env_?.API_BASE_URL) {
    return window._env_.API_BASE_URL;
  }
  switch (process.env.NODE_ENV) {
    case 'development':
      return 'http://localhost:3000';//http://192.168.0.102:3000
    case 'debug':
      return 'http://localhost:4001';
    case 'production':
    default:
      return 'http://119.23.79.194';
  }
};

// 设置全局 baseURL
axios.defaults.baseURL = getApiBaseUrl();

//设置请求超时
axios.defaults.timeout=1*60*1000

// 设置两次请求间隔时间（毫秒）
const requestInterval = 5000;

// 记录上一次请求的时间戳
let lastRequestTime = 0;

//请求拦截器
axios.interceptors.request.use(
  config => {

    // 发送请求的数据中CCR为false时不用检查连续发送请求
    if(config.data.CCR === undefined || config.data.CCR){
    // 防止连续发送请求-------------------------------------------
    const currentTime = Date.now();
    const timeSinceLastRequest = currentTime - lastRequestTime;
    // 如果距离上一次请求的时间小于两次请求间隔时间，则中断当前请求并抛出错误
    if (timeSinceLastRequest < requestInterval) {
      return Promise.reject({code:100,message:'快速请求，中断请求'+currentTime+'@'+lastRequestTime});
    }
    lastRequestTime = currentTime;
    //-----------------------------------------------------------
    };

    // 从缓存中取出token字符串-------------------------------------
    const token = localStorage.getItem('token')
    //如果有token字符串，把token字符串放在报文头Authorization中
    token && (config.headers.Authorization = 'Bearer '+ token);  //注意'Bearer '中有一个空格
    //-----------------------------------------------------------

    return config;
  },
  error  => {
    return Promise.error(error)
  }
);



// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // response的数据格式：{config:,data:,headers:,request:,status:,statusText:'OK'}，
    // 服务器端send返回的数据是放在data中。
    if (response.status === 200) {
      
      const code=response.data.code;
      if(code===1){  //1代表登录成功
        const token=response.data.token
        //如果有token字符串，把token放到浏览器的缓存
        token && localStorage.setItem('token',token)
      };
      return Promise.resolve(response);
    } else {
      return handleError(response);
    }
  },
  error => {
    return handleError(error);
  }
);

// 错误信息处理函数，统一格式{code:123,message:'错误说明'}
function handleError(error) {
  let errorMsg = {code: 888, message: 'Unknown error!'};// '未知错误!'
  if (error.response) {
    switch (error.response.status) {
      case 401:
        errorMsg.message = 'Login expired, please log in again!';// '登录过期，请重新登录！'
        errorMsg.code = 401;
        break;
      case 404:
        errorMsg.message = 'File does not exist!';// '文件不存在！'
        errorMsg.code = 404;
        break;
      case 500:
        errorMsg.message = 'Server-side error!';// 服务器端发生错误！
        errorMsg.code = 500;
        break;
      default:
        errorMsg.message = 'Unknown error!';
        break;
    }
  } else if (error.request) {
    if (error.message === 'Network Error'){
      errorMsg.message = 'Incorrect request address or disconnected from the internet!';// 请求地址错误或者断网了！
      errorMsg.code = 301;
    } else if(error.message.includes('timeout')){
      errorMsg.message = 'Server did not respond!';// 服务器没有作出响应！
      errorMsg.code = 302;
    }
  } else {
    if (error.code === 100) {
      errorMsg.message = 'Please do not make rapid requests!';// 请勿快速请求！
      errorMsg.code = 100;
    }
  }
  return Promise.reject(errorMsg);
}


/*********************************************
* get方法，对应get请求
* @param {String} url [请求的url地址]
* @param {Object} params [请求时携带的参数]
**********************************************/
export function get(url, params){
  return new Promise((resolve, reject) =>{
    axios.get(url, {params: params})
    .then(res => {
      resolve(res.data);
    })
    .catch(err =>{
      reject(err.data)
    })
  });
}

/*********************************************
 	* post方法，对应post请求
 	* @param {String} url [请求的url地址]
 	* @param {Object} params [请求时携带的参数]
**********************************************/
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)   //QS.stringify(params)
    .then(res => {
      resolve(res.data);
    })
    .catch(err =>{
      reject(err)
    })
  });
};

/*********************************************
 	* download方法，post请求
 	* @param {String} url [请求的url地址]
 	* @param {Object} params [请求时携带的参数]
 	* @param {Object} fn [回调函数，下载的进度]
**********************************************/
export function download(url, params, fn) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      responseType: 'blob', // 关键：指定响应类型为blob
      onDownloadProgress:fn,
      timeout: 600000
    })
    .then(res => {
      resolve(res.data);
    })
    .catch(err =>{
      reject(err)
    })
  });
};